import React from 'react';
import './sectionOne.scss';
import chatImage from '../../../resources/AskEPM-chat-windows.svg'; 

const SectionOne = () => {
    
    const handleDemoClick = () => {
        if (typeof document !== 'undefined') {
            window.location = '/contact';
        }
    };

    return (
        <div id='AiTools' className='ai-tools-section'>
            <div className='ai-tools-container'>
                <div className='ai-tools-left'>
                    <div className='subtitle-wrapper'>
                        <p className='subtitle'>ASK EPM</p>
                    </div>
                    <h1 className='main-heading'>
                        AskEPM + <span className='highlight'>Agentic AI</span>
                    </h1>
                    <p className='description'>
                        Natural-language access to the connected operating model, with governed agents that move from question to action and measured impact.
                    </p>
                    <button
                        onClick={handleDemoClick}
                        className='epm-hero__button epm-hero__button--primary'
                        style={{ width: '152px' }}
                    >
                        Schedule Demo
                    </button>
                </div>
                <div className='ai-tools-right'>
                    <img
                        className='chat-window-image'
                        src={chatImage}
                        alt='AskEPM Chat Interface'
                    />
                </div>
            </div>
        </div>
    );
};

export default SectionOne;